import { deleteCall, getCall, postCall, putCall } from "../utils/calls";
import {
  dispatchErrorMessage,
  loadingToast,
  updateToast,
} from "../utils/toast";

export const getStyle = async () => {
  const bot_id = localStorage.getItem("bot");
  const res = await getCall("/bots/styles/" + bot_id);
  if (res[0]) {
    return res[0].data;
  } else return null;
};
export const getStateIcons = async () => {
  const bot_id = localStorage.getItem("bot");
  const res = await getCall("/bots/webchat/parameters/" + bot_id);
  if (res[0]) {
    return res[0].webchat_parameters;
  } else return null;
};

export const saveChangeStateIcons = async (data) => {
  const bot_id = localStorage.getItem("bot");
  const res = await putCall("/bots/webchat/parameters/" + bot_id, data);
  if (res[0]) {
    return res[0];
  } else {
    return null;
  }
};
export const saveMessageIcon = async (data) => {
  const bot_id = localStorage.getItem("bot");
  const id = loadingToast();
  const res = await putCall("/bots/webchat/parameters/message/" + bot_id, {
    whatsapp_message: data,
  });
  if (res[0]) {
    updateToast(id, "success", "Mensaje guardado con éxito.");
    return res[0];
  } else {
    dispatchErrorMessage(id, res, "Error al guardar mensaje.");
    return null;
  }
};

export const getConfig = async () => {
  const bot_id = localStorage.getItem("bot");
  const res = await getCall("/bots/" + bot_id);
  if (res[0]) {
    return res[0];
  } else return null;
};

export const getReminderConfig = async () => {
  const bot_id = localStorage.getItem("bot");
  const res = await getCall("/reminders/" + bot_id);
  if (res[0]) {
    return res[0].reminders_config;
  } else return null;
};

export const saveReminderConfig = async (data) => {
  const bot_id = localStorage.getItem("bot");
  const id = loadingToast();
  const res = await putCall("/reminders/" + bot_id, data);
  if (res[0]) {
    updateToast(id, "success", "Guardado con éxito.");
    return res[0];
  } else {
    dispatchErrorMessage(id, res, "Error al guardar.");
    return null;
  }
};

export const saveReactivationConfig = async (data) => {
  const bot_id = localStorage.getItem("bot");
  const id = loadingToast();
  const res = await putCall("/bots/reactivation/message/" + bot_id, data);
  if (res[0]) {
    updateToast(id, "success", "Guardado con éxito.");
    return res[0];
  } else {
    dispatchErrorMessage(id, res, "Error al guardar.");
    return null;
  }
};

export const saveConfig = async (data) => {
  const bot_id = localStorage.getItem("bot");
  const id = loadingToast();
  const res = await putCall("/bots/" + bot_id, data);
  if (res[0]) {
    updateToast(id, "success", "Guardado con éxito.");
    return res[0];
  } else {
    dispatchErrorMessage(id, res, "Error al guardar.");
    return null;
  }
};

// export const getWSP = async () => {
//   const bot_id = localStorage.getItem("bot");
//   const res = await getCall("/bots/whatsapp/" + bot_id);
//   if (res[0]) {
//     return res[0].whatsapp_config;
//   } else return null;
// };
export const getRequestConfig = async () => {
  const bot_id = localStorage.getItem("bot");
  const res = await getCall("/bots/contact/" + bot_id);
  if (res[0]) {
    return res[0].contact_params;
  } else return null;
};
export const editRequestConfig = async (data) => {
  const bot_id = localStorage.getItem("bot");
  const id = loadingToast();
  const res = await putCall("/bots/contact/" + bot_id, data);
  if (res[0]) {
    updateToast(id, "success", "Cambios guardados correctamente.");
    return res[0];
  } else {
    dispatchErrorMessage(id, res, "Error al guardar cambios.");
    return null;
  }
};
export const getContactData = async () => {
  const bot_id = localStorage.getItem("bot");
  const res = await getCall("/bots/notifications/contacts/" + bot_id);
  if (res[0]) {
    return res[0];
  } else return null;
};
export const getNotifications = async () => {
  const bot_id = localStorage.getItem("bot");
  const res = await getCall("/bots/notifications/" + bot_id);
  if (res[0]) {
    return res[0].notifications;
  } else return null;
};
export const saveNotifications = async (data) => {
  const bot_id = localStorage.getItem("bot");
  const res = await putCall("/bots/notifications/" + bot_id, data);
  if (res[0]) {
    return res[0];
  } else return null;
};

export const saveContactData = async (contact, type) => {
  //1 contact/general
  //2 tracker
  //3 areas
  //4 train
  const bot_id = localStorage.getItem("bot");
  const id = loadingToast();
  let data = {
    contact_id: contact.id,
    type:
      type === "general"
        ? 1
        : type === "tracker"
        ? 2
        : type === "area"
        ? 3
        : type === "train" && 4,
  };
  if (contact.contacts && contact.contacts.name) {
    data = { ...data, contact: contact.contacts };
    if (data.contact.phone.length < 6) {
      data.contact.phone = "";
    }
  }
  const res = await postCall("/bots/" + bot_id, data);
  if (res[0]) {
    updateToast(id, "success", "Contacto guardado correctamente.");
    return res[0];
  } else {
    dispatchErrorMessage(id, res, "Error al agregar contacto.");
    return null;
  }
};

export const saveNewContactArea = async (contact, areaSelected) => {
  const bot_id = localStorage.getItem("bot");
  const id = loadingToast();
  let data = {
    contact_id: contact.id,
    id: areaSelected.id,
  };
  if (contact.contacts && contact.contacts.name) {
    data = { ...data, contact: contact.contacts };
    if (data.contact.phone.length < 6) {
      data.contact.phone = "";
    }
  }
  const res = await postCall("/bots/areas/contacts/" + bot_id, data);
  if (res[0]) {
    updateToast(id, "success", "Contacto guardado correctamente.");
    return res[0].contact_receiver;
  } else {
    dispatchErrorMessage(id, res, "Error al agregar contacto.");
    return null;
  }
};

export const saveEditContactConfig = async (contact) => {
  const bot_id = localStorage.getItem("bot");
  const id = loadingToast();
  const res = await putCall("/bots/areas/" + bot_id, {
    name: contact.area,
    area_id: contact.id,
    code: contact.code,
    is_contactable: contact.isContactable
  });
  if (res[0]) {
    updateToast(id, "success", "Área editada correctamente.");
    return res[0].area;
  } else {
    dispatchErrorMessage(id, res, "Error al editar el área.");
    return null;
  }
};

export const addNewArea = async (data) => {
  const bot_id = localStorage.getItem("bot");
  const id = loadingToast();
  const res = await postCall("/bots/areas/" + bot_id, { 
    area: data.area, 
    code: data.code,
    is_contactable: data.isContactable
  });
  if (res[0]) {
    updateToast(id, "success", "Área agregada correctamente.");
    return res[0].new_area;
  } else {
    dispatchErrorMessage(id, res, "Error al agregar el área.");
    return null;
  }
};

export const orderAreas = async (data) => {
  const bot_id = localStorage.getItem("bot");
  const res = await postCall(
    "/bots/areas/order/" + bot_id,
    data
  );
  if (res[0]) {
    return res[0];
  } else return null;
};

export const deleteContactData = async (idContact) => {
  const bot_id = localStorage.getItem("bot");
  const id = loadingToast();
  const res = await deleteCall("/bots/" + bot_id + "/" + idContact);
  if (res[0]) {
    updateToast(id, "success", "Contacto borrado correctamente.");
    return res[0];
  } else {
    dispatchErrorMessage(id, res, "Error al borrar el contacto.");
    return null;
  }
};
export const deleteContactArea = async (idArea) => {
  const bot_id = localStorage.getItem("bot");
  const id = loadingToast();
  const res = await deleteCall("/bots/areas/" + bot_id + "/" + idArea);
  if (res[0]) {
    updateToast(id, "success", "Área borrada correctamente.");
    return res[0];
  } else {
    dispatchErrorMessage(id, res, "Error al borrar el área");
    return null;
  }
};

export const saveStyle = async (
  botImg,
  theme,
  openIcon,
  closeIcon,
  title,
  subtitle
) => {
  const bot_id = localStorage.getItem("bot");
  const id = loadingToast();

  const data = {
    "avatar-value": botImg.img,
    "title-value": title,
    "subtitle-value": subtitle,
    "open-value": openIcon,
    "close-value": closeIcon,
    "theme-value": theme.type,
    primary_color: theme.colors.primary,
    background_color: theme.colors.background,
    user_message_color: theme.colors.userMessage,
    bot_message_color: theme.colors.botMessage,
    button_color: theme.colors.button,
    button_hover_color: theme.colors.buttonHover,
  };
  const res = await putCall("/bots/edit/bot/styles/" + bot_id, data);
  if (res[0]) {
    updateToast(id, "success", "Guardado con éxito");
    return res[0];
  } else {
    dispatchErrorMessage(id, res, "Error al guardar");
    return null;
  }
};

export const getAccessUser = async () => {
  const bot_id = localStorage.getItem("bot");
  const res = await getCall("/access/" + bot_id);
  if (res[0]) {
    return res[0];
  } else return null;
};

export const deleteAccessCompany = async (user) => {
  const bot_id = localStorage.getItem("bot");
  const id = loadingToast();
  const res = await deleteCall("/access/" + bot_id + "/" + user.company_id);
  if (res[0]) {
    updateToast(id, "success", "Grupo borrado con éxito.");
    return res[0];
  } else {
    dispatchErrorMessage(id, res, "Error al borrar el grupo.");
    return null;
  }
};

export const deleteAccessUser = async (user) => {
  const bot_id = localStorage.getItem("bot");
  const id = loadingToast();
  const res = await deleteCall("/access/delete/" + bot_id + "/" + user.id);
  if (res[0]) {
    updateToast(id, "success", "Acceso borrado con éxito.");
    return res[0];
  } else {
    dispatchErrorMessage(id, res, "Error al borrar el acceso.");
    return null;
  }
};

export const saveNewAccessUser = async (contact, company_id) => {
  const bot_id = localStorage.getItem("bot");
  const id = loadingToast();
  let data = {
    contact_id: contact.id,
    company_id: company_id,
  };
  if (!contact.id) {
    data = { ...data, contact: contact };
    if (data.contact.phone.length < 6) {
      data.contact.phone = "";
    }
  }
  const res = await postCall("/access/add/" + bot_id, data);
  if (res[0]) {
    updateToast(id, "success", "Contacto agregado correctamente.");
    return res[0].contact;
  } else {
    dispatchErrorMessage(id, res, "Error al agregar el contacto.");
    return null;
  }
};

export const getBannedUsers = async () => {
  const bot_id = localStorage.getItem("bot");
  const res = await getCall("/access/contacts/banned/" + bot_id);
  console.log(res);
  if (res[0]) {
    return res[0].banned_users;
  } else return null;
};

export const toggleAccessAll = async (access) => {
  const bot_id = localStorage.getItem("bot");
  const data = { access_all: access };
  const res = await putCall("/access/toggle/" + bot_id, data);
  if (res[0]) {
    return res[0];
  } else return null;
};

export const toggleAccessCompany = async (company) => {
  const bot_id = localStorage.getItem("bot");
  const res = await putCall("/access/" + bot_id + "/" + company);
  if (res[0]) {
    return res[0];
  } else return null;
};

export const toggleContactArea = async (contact_id) => {
  const bot_id = localStorage.getItem("bot");
  const res = await putCall(
    "/bots/areas/contacts/toggle/" + bot_id + "/" + contact_id
  );
  if (res[0]) {
    return res[0];
  } else return null;
};

export const blockContact = async (contact, block) => {
  const bot_id = localStorage.getItem("bot");
  const id = loadingToast();
  let data = { id: contact.id, blocked: block };
  if (!contact.id) {
    data = { ...data, contact: contact };
    if (data.contact.phone.length < 6) {
      data.contact.phone = "";
    }
  }
  const res = await putCall("/contacts/block/" + bot_id, data);
  if (res[0]) {
    updateToast(id, "success", "Contacto bloqueado correctamente.");
    return res[0];
  } else {
    dispatchErrorMessage(id, res, "Error al bloquear el contacto.");
    return null;
  }
};

export const getAreas = async () => {
  const bot_id = localStorage.getItem("bot");
  const res = await getCall("/bots/areas/" + bot_id);
  if (res[0]) {
    return res[0].areas;
  } else return null;
};

export const getAreasWithUsers = async () => {
  const bot_id = localStorage.getItem("bot");
  const res = await getCall("/bots/areas/with-users/" + bot_id);
  if (res[0]) {
    return res[0].data;
  } else return null;
};

export const getContactsArea = async (area_id) => {
  const bot_id = localStorage.getItem("bot");
  const res = await getCall("/bots/contacts/" + bot_id + "/" + area_id);
  if (res[0]) {
    return res[0].contacts;
  } else return null;
};

export const changeShareContacts = async () => {
  const bot_id = localStorage.getItem("bot");
  const res = await putCall("/bots/share/contacts/" + bot_id);
  if (res[0]) {
    return res[0];
  } else {
    return null;
  }
};

export const toggleOutOfTimeMsgEnabled = async () => {
  const bot_id = localStorage.getItem("bot");
  const res = await putCall("/bots/handoff/toggle/out/schedule/message/" + bot_id);
  if (res[0]) {
    return res[0].config_handoff?.out_of_time_msg_enabled;
  } else {
    return null;
  }
};

export const getBotState = async () => {
  const bot_id = localStorage.getItem("bot");
  const res = await getCall("/bots/state/" + bot_id);
  if (res[0]) {
    return res[0];
  } else return null;
};

export const saveSurveyTimeout = async (data) => {
  const bot_id = localStorage.getItem("bot");
  const res = await putCall("/bots/survey/timeout/" + bot_id, data);
  if (res[0]) {
    return res[0];
  } else return null;
};

export const setDefaultArea = async (areaId) => {
  const bot_id = localStorage.getItem("bot");
  let data = {area_id: areaId}
  const res = await putCall("/bots/areas/default/" + bot_id, data);
  if (res[0]) {
    return res[0];
  } else {
    return null;
  }
};

export const changeBotState = async () => {
  const bot_id = localStorage.getItem("bot");
  const res = await putCall("/bots/state/" + bot_id);
  if (res[0]) {
    // updateToast(id, "success", "Contacto bloqueado correctamente");
    return res[0];
  } else {
    const id = loadingToast();
    dispatchErrorMessage(id, res, "Error al cambiar estado del chatbot.");
    return null;
  }
};

export const changeTaggingSetting = async () => {
  const bot_id = localStorage.getItem("bot");
  const res = await putCall("/bots/tagging/" + bot_id);
  if (res[0]) {
    return res[0].tagging_config;
  } else {
    const id = loadingToast();
    dispatchErrorMessage(id, res, "Error al cambiar configuración de etiquetado automático.");
    return null;
  }
};

export const saveApiTimeout = async (data) => {
  const bot_id = localStorage.getItem("bot");
  const id = loadingToast();
  const res = await putCall("/bots/api/timeout/" + bot_id, {
    api_request_timeout: Number(data),
  });
  if (res[0]) {
    updateToast(id, "success", "Cambios guardados correctamente.");
    return res[0];
  } else {
    dispatchErrorMessage(id, res, "Error al guardar los cambios.");
    return null;
  }
};

export const saveGoogleRatingURL = async (url) => {
  const bot_id = localStorage.getItem("bot");
  const id = loadingToast();
  const res = await putCall("/bots/rating-url/" + bot_id, {
    business_rating_url: url,
  });
  if (res[0]) {
    updateToast(id, "success", "URL guardada correctamente.");
    return res[0];
  } else {
    dispatchErrorMessage(id, res, "Error al guardar la URL.");
    return null;
  }
};

export const saveLeadsConfig = async (data) => {
  const bot_id = localStorage.getItem("bot");
  const id = loadingToast();
  const res = await putCall("/bots/handoff/export-lead/" + bot_id, data);
  if (res[0]) {
    updateToast(id, "success", "Configuración guardada correctamente.");
    return res[0];
  } else {
    dispatchErrorMessage(id, res, "Error al guardar la configuración.");
    return null;
  }
};

export const saveBufferMsgSettings = async (data) => {
  const bot_id = localStorage.getItem("bot");
  const id = loadingToast();
  const res = await putCall("/bots/msg-buffer/" + bot_id, data);
  if (res[0]) {
    updateToast(id, "success", "Buffer de mensajes editado con éxito.");
    return res[0];
  } else {
    dispatchErrorMessage(id, res, "Error al guardar el buffer de mensajes.");
    return null;
  }
};

// OUTPUT MESSAGE BUFFER SETTINGS METHODS
export const saveOutputBufferMsgSettings = async (data) => {
  const bot_id = localStorage.getItem("bot");
  const id = loadingToast();
  const res = await putCall("/bots/output-msg-buffer/" + bot_id, data);
  if (res[0]) {
    updateToast(id, "success", "Buffer de mensajes editado con éxito.");
    return res[0];
  } else {
    dispatchErrorMessage(id, res, "Error al guardar el buffer de mensajes.");
    return null;
  }
};